var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestroom = function SvgRestroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "m4.535 21.832 1.04-1.953m13.89 1.953-1.04-1.953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.857 9.428c0-.473.384-.857.857-.857h20.572c.473 0 .857.384.857.857v4.286a6 6 0 0 1-6 6H6.857a6 6 0 0 1-6-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M5.143 8.572V3.429a1.714 1.714 0 0 1 3.429 0v.343"
  })));
};
export default SvgRestroom;